"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMarkToolbarButtonState = exports.useMarkToolbarButton = void 0;
var _plateCommon = require("@udecode/plate-common");
/* copied from v36 plate repo it should be updated to use the new version
 * I needed to change the imports from @udecode/slate-utils and slate-core to @udecode/plate-common for it to work
 **/

var useMarkToolbarButtonState = function useMarkToolbarButtonState(_ref) {
  var clear = _ref.clear,
    nodeType = _ref.nodeType;
  var pressed = (0, _plateCommon.useEditorSelector)(function (editor) {
    return (0, _plateCommon.isMarkActive)(editor, nodeType);
  }, [nodeType]);
  return {
    clear: clear,
    nodeType: nodeType,
    pressed: pressed
  };
};
exports.useMarkToolbarButtonState = useMarkToolbarButtonState;
var useMarkToolbarButton = function useMarkToolbarButton(state) {
  var editor = (0, _plateCommon.useEditorRef)();
  return {
    props: {
      onClick: function onClick() {
        (0, _plateCommon.toggleMark)(editor, {
          clear: state.clear,
          key: state.nodeType
        });
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      },
      pressed: state.pressed
    }
  };
};
exports.useMarkToolbarButton = useMarkToolbarButton;